<span class="example-pizza-party">
  {{ message }}
</span>
